<div class="main">
  <header>
    <app-header></app-header>
  </header>
  <div class="main-content">
    <router-outlet></router-outlet>
    <footer class="footer">
      <app-footer></app-footer>
    </footer>
  </div>
</div>
